import React from 'react';
import { Switch, Route } from 'react-router-dom';

import IndustryReport from './industry-reports';
import ReportDescription from '../report-description/report-description';
import IndustryReportCategory from './industry-report-category/industry-report-category';


const IndustryReportRouter = () => (
    <div>

    <Switch>
        <Route exact path='/industry-reports' component={IndustryReport}/>
        <Route exact path='/industry-reports/:slug' component={ReportDescription}/>
        <Route exact path='/industry-reports/category/:slug' component={IndustryReportCategory}/>
        <Route exact path='/industry-reports/category/:slug/:sub' component={IndustryReportCategory}/>
    </Switch>
    </div>
)



export default IndustryReportRouter;


// WEBPACK FOOTER //
// ./src/industry-reports/industry-report-router.js